/**
 **@author       yontaek@zumper.com (Yon Taek Chung)
 **@copyright    Copyright (c) 2024, Zumper
 */

import { buildSrc } from '@zcode/image-cdn-utils'
import atlanta from './img/atlanta.webp'
import austin from './img/austin.webp'
import boston from './img/boston.webp'
import chicago from './img/chicago.webp'
import dallas from './img/dallas.webp'
import houston from './img/houston.webp'
import losAngeles from './img/losangeles.webp'
import miami from './img/miami.webp'
import montreal from './img/montreal.webp'
import newyorkcity from './img/newyorkcity.webp'
import ottawa from './img/ottowa.webp'
import phoenix from './img/phoenix.webp'
import sanFrancisco from './img/sanfrancisco.webp'
import toronto from './img/toronto.webp'
import vancouver from './img/vancouver.webp'

export const HOMEPAGE_POPULAR_CITIES = [
  {
    text: 'New York, NY',
    url: 'new-york-ny',
    image: buildSrc(newyorkcity, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'San Francisco, CA',
    url: 'san-francisco-ca',
    image: buildSrc(sanFrancisco, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Atlanta, GA',
    url: 'atlanta-ga',
    image: buildSrc(atlanta, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Chicago, IL',
    url: 'chicago-il',
    image: buildSrc(chicago, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Toronto, ON',
    url: 'toronto-on',
    image: buildSrc(toronto, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Vancouver, BC',
    url: 'vancouver-bc',
    image: buildSrc(vancouver, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Los Angeles, CA',
    url: 'los-angeles-ca',
    image: buildSrc(losAngeles, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Dallas, TX',
    url: 'dallas-tx',
    image: buildSrc(dallas, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Ottawa, ON',
    url: 'ottawa-on',
    image: buildSrc(ottawa, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Montreal, QC',
    url: 'montreal-qc',
    image: buildSrc(montreal, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Austin, TX',
    url: 'austin-tx',
    image: buildSrc(austin, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Boston, MA',
    url: 'boston-ma',
    image: buildSrc(boston, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Miami, FL',
    url: 'miami-fl',
    image: buildSrc(miami, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Phoenix, AZ',
    url: 'phoenix-az',
    image: buildSrc(phoenix, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
  {
    text: 'Houston, TX',
    url: 'houston-tx',
    image: buildSrc(houston, {
      fit: 'clip',
      h: 300,
      w: 300,
    }),
  },
] as const
